/* Ivevar: discount code badges, auto-apply best code, free gift in cart (Oct 2026) */
(function () {
  if (window.__ivd) return;
  window.__ivd = true;

  // Keep in sync with snippets/ivd-tier.liquid and snippets/ivd-badge.liquid (amounts in cents, USD)
  var IVD_TIERS = [
    { min: 400000, code: 'WELCOME30', pct: 30 },
    { min: 300000, code: 'VIP25', pct: 25 },
    { min: 200000, code: 'WELCOME20', pct: 20 },
    { min: 100000, code: 'WELCOME15', pct: 15 },
    { min: 29900, code: 'WELCOME10', pct: 10 },
    { min: 1, code: 'IVEVAR10', pct: 10 }
  ];
  var OFF_KEY = 'ivd_code_off';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function tierFor(cents) {
    for (var i = 0; i < IVD_TIERS.length; i++) if (cents >= IVD_TIERS[i].min) return IVD_TIERS[i];
    return null;
  }
  function money(cents) {
    var n = Math.round(cents) / 100;
    var s = n % 1 === 0 ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '<span class="money">$' + s + '</span>';
  }
  function store(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  // A free gift = line marked _gift, or a product of type "Free Gift" (made free at checkout by the automatic "FREE GIFT with any order" discount)
  function isGift(item) { return !!item && ((item.properties && String(item.properties._gift).toLowerCase() === 'true') || item.product_type === 'Free Gift'); }
  function postJSON(url, body) {
    return fetch(root + url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function drawerEl() { return document.querySelector('m-cart-drawer'); }
  function refreshUI() {
    var d = drawerEl();
    if (d && typeof d.onCartDrawerUpdate === 'function') d.onCartDrawerUpdate(true);
    var page = document.querySelector('m-cart-template');
    if (page && typeof page.onCartUpdate === 'function') page.onCartUpdate(true);
  }
  function busy(on) {
    var els = document.querySelectorAll('m-cart-drawer, m-cart-template');
    for (var i = 0; i < els.length; i++) els[i].classList.toggle('is-ivd-busy', !!on);
  }

  /* ---------- Copy code (product cards) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ivd-copy]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var code = btn.getAttribute('data-ivd-copy');
    var done = function () {
      btn.classList.add('is-copied');
      setTimeout(function () { btn.classList.remove('is-copied'); }, 1400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else {
      var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t); done();
    }
  }, true);

  /* ---------- Apply / remove code ---------- */
  function applyCode(code) {
    store(OFF_KEY, null);
    busy(true);
    return postJSON('cart/update.js', { discount: code })
      .catch(function () {})
      .then(function () { return fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}); })
      .then(function () { busy(false); refreshUI(); });
  }
  function removeCode() {
    store(OFF_KEY, '1');
    busy(true);
    return postJSON('cart/update.js', { discount: '' })
      .catch(function () {})
      .then(function () { busy(false); refreshUI(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var apply = t.closest('[data-ivd-apply]');
    if (apply) {
      e.preventDefault(); e.stopPropagation();
      var code = apply.getAttribute('data-ivd-apply');
      if (apply.classList.contains('ivd-pdp__apply')) {
        apply.textContent = 'Applying…';
        applyCode(code).then(function () {
          apply.textContent = 'Applied ✓';
          apply.classList.add('is-applied');
        });
      } else {
        applyCode(code);
      }
      return;
    }
    var rem = t.closest('[data-ivd-remove]');
    if (rem) { e.preventDefault(); e.stopPropagation(); removeCode(); return; }

    var gift = t.closest('[data-ivd-gift]');
    if (gift) {
      e.preventDefault(); e.stopPropagation();
      if (gift.classList.contains('is-selected') || gift.disabled) return;
      selectGift(parseInt(gift.getAttribute('data-ivd-gift'), 10));
    }
  }, true);

  /* ---------- Free gift ---------- */
  function selectGift(variantId) {
    busy(true);
    return getCart().then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) { if (isGift(it)) updates[it.key] = 0; });
      var p = Object.keys(updates).length ? postJSON('cart/update.js', { updates: updates }) : Promise.resolve();
      return p.then(function () {
        return postJSON('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _gift: 'true' } }] });
      });
    }).catch(function () {}).then(function () { busy(false); reconcile(); refreshUI(); });
  }

  /* ---------- Reconcile: gift + best discount code ---------- */
  var reconciling = false, again = false;
  function reconcile() {
    if (reconciling) { again = true; return; }
    reconciling = true;
    var summary = document.querySelector('[data-ivd-summary]');
    var giftDefault = summary ? parseInt(summary.getAttribute('data-gift-default') || '0', 10) : 0;

    getCart().then(function (cart) {
      var gifts = [], paid = 0, paidCount = 0;
      cart.items.forEach(function (it) {
        if (isGift(it)) gifts.push(it);
        else { paid += it.original_line_price; paidCount += it.quantity; }
      });
      var jobs = [];
      var changed = false;

      // Gifts: never alone, never more than one, never more than qty 1
      if (paidCount === 0 && gifts.length) {
        var upd = {}; gifts.forEach(function (g) { upd[g.key] = 0; });
        jobs.push(function () { return postJSON('cart/update.js', { updates: upd }); });
        changed = true;
      } else if (gifts.length > 1 || (gifts[0] && gifts[0].quantity > 1)) {
        var upd2 = {};
        gifts.forEach(function (g, i) { upd2[g.key] = i === 0 ? 1 : 0; });
        jobs.push(function () { return postJSON('cart/update.js', { updates: upd2 }); });
        changed = true;
      } else if (paidCount > 0 && gifts.length === 0 && giftDefault) {
        jobs.push(function () { return postJSON('cart/add.js', { items: [{ id: giftDefault, quantity: 1, properties: { _gift: 'true' } }] }); });
        changed = true;
      }

      // Discount: best tier for paid subtotal, unless customer removed it this session
      var tier = tierFor(paid);
      var codes = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
      var off = read(OFF_KEY) === '1';
      if (paidCount === 0) {
        if (codes.length) { jobs.push(function () { return postJSON('cart/update.js', { discount: '' }); }); changed = true; }
      } else if (!off && tier && (codes.length !== 1 || codes[0] !== tier.code)) {
        var knownTier = codes.length === 0 || codes.every(function (c) { return IVD_TIERS.some(function (t) { return t.code === c; }); });
        // Respect a code the customer typed themselves (e.g. from an email); only switch our own tier codes
        if (knownTier) {
          jobs.push(function () { return postJSON('cart/update.js', { discount: tier.code }); });
          changed = true;
        }
      }

      if (!jobs.length) return false;
      busy(true);
      return jobs.reduce(function (p, job) { return p.then(job); }, Promise.resolve()).then(function () { return changed; });
    }).catch(function () { return false; }).then(function (changed) {
      busy(false);
      reconciling = false;
      if (changed) refreshUI();
      if (again) { again = false; setTimeout(reconcile, 50); }
    });
  }
  window.ivdReconcile = reconcile;

  function onReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  onReady(function () {
    reconcile();
    var tries = 0;
    (function hook() {
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, function () { setTimeout(reconcile, 400); });
      } else if (tries++ < 40) setTimeout(hook, 250);
    })();
    // Before going to checkout: make sure the gift/discount state is final
    document.addEventListener('click', function (e) {
      var co = e.target.closest && e.target.closest('[name="checkout"]');
      if (!co || co.__ivdOk) return;
      e.preventDefault(); e.stopImmediatePropagation();
      busy(true);
      getCart().then(function (cart) {
        var paidCount = 0;
        cart.items.forEach(function (it) { if (!isGift(it)) paidCount += it.quantity; });
        if (paidCount === 0) {
          var upd = {}; cart.items.forEach(function (it) { upd[it.key] = 0; });
          return postJSON('cart/update.js', { updates: upd }).then(function () { busy(false); refreshUI(); return false; });
        }
        return true;
      }).catch(function () { return true; }).then(function (go) {
        busy(false);
        if (!go) return;
        co.__ivdOk = true;
        co.click();
        setTimeout(function () { co.__ivdOk = false; }, 2000);
      });
    }, true);
  });

  /* ---------- Product page: keep the code box in sync with the selected variant ---------- */
  function syncPdp() {
    var box = document.querySelector('[data-ivd-pdp]');
    if (!box) return;
    var map; try { map = JSON.parse(box.getAttribute('data-ivd-variants') || '{}'); } catch (e) { map = {}; }
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var vid = input && input.value ? input.value : (new URLSearchParams(location.search).get('variant'));
    if (!vid || map[vid] === undefined) return;
    if (box.__vid === vid) return;
    box.__vid = vid;
    var price = map[vid];
    var tier = tierFor(price);
    if (!tier) { box.hidden = true; return; }
    box.hidden = false;
    // whole dollars, so the currency app converts it exactly like the product price
    var pay = Math.round((price - Math.floor(price * tier.pct / 100)) / 100) * 100;
    box.querySelector('[data-ivd-pct]').textContent = tier.pct;
    box.querySelector('[data-ivd-code]').textContent = tier.code;
    box.querySelector('[data-ivd-pay]').innerHTML = money(pay);
    var btn = box.querySelector('[data-ivd-apply]');
    if (btn) { btn.setAttribute('data-ivd-apply', tier.code); btn.textContent = 'Apply'; btn.classList.remove('is-applied'); }
  }
  onReady(function () {
    if (!document.querySelector('[data-ivd-pdp]')) return;
    syncPdp();
    document.addEventListener('change', function () { setTimeout(syncPdp, 60); }, true);
    document.addEventListener('click', function () { setTimeout(syncPdp, 120); }, true);
    var last = location.href;
    setInterval(function () { if (location.href !== last) { last = location.href; syncPdp(); } }, 500);
  });
})();
